<template>
  <div
    v-if="$login.can('companies.create')"
    class="companies-create"
  >
    <page-header header="Create new company">
      <router-link
        :to="{ name: 'companies.create-manually' }"
        v-if="$login.can('companies.create-manually')"
        class="btn btn-primary"
      >
        Create manually
      </router-link>
    </page-header>
    <div class="mt-4">
      <request-form
        @submit="submitRequest"
        :error="error"
        v-model="company"
      >
        <div class="w-100 mt-4 py-4 d-flex border-top">
          <button
            class="ml-auto btn btn-primary "
          >
            Send request
          </button>
        </div>
      </request-form>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import {infoNotification, successNotification} from '@/notifications'
import {debounce} from '@/helpers'
import RequestForm from './Form'

export default {
  name: 'MarketsInfoStep',

  props: {
  },

  components: {
    VueGoodTable,
    RequestForm,
  },

  watch: {
    searchQuery: debounce(function () {
      this.searchCompanies()
    }, 750),
    searchTickerQuery: debounce(function () {
      this.searchSecurities()
    }, 750),
  },

  data () {
    return {
      searched: true,
      searchQuery: '',
      searchTickerQuery: '',
      options: [],
      requestActive: false,
      securityOptions: [],
      company: {},
      error: null,
      companyColumns: [
        {
          field: 'name',
          label: 'Name',
        },
        {
          field: 'symbol',
          label: 'Ticker',
        },
        {
          field: 'type',
          label: 'Type',
        },
      ],
      securityColumns: [
        {
          field: 'fullnm',
          label: 'Name',
        },
        {
          field: 'isin',
          label: 'ISIN',
        },
      ],
    }
  },

  methods: {
    async searchCompanies () {
      if (this.searchQuery) {
        const {data} = await this.$http.get(`companies/create-search/${this.searchQuery}`)

        this.options = Object.values(data)
        this.securityOptions = []

        this.searched = true
      }
    },
    async searchCompaniess () {
      const response = this.$http.post(`https://www.investing.com/search/service/searchTopBar`, {
        data: {
          search_text: this.searchQuery,
        }
      })

      console.log(response)
    },
    async searchSecurities () {
      if (this.searchTickerQuery) {
        const {data} = await this.$http.get(`companies/rapido/securities/${this.searchTickerQuery}`)
        console.log(data)
        this.options = []
        this.securityOptions = data.data
      }
    },

    async create ({row}) {
      const company = row
      if (company.model) {
        const {data} = await this.$http.get(`companies/rapido/${company.model.id}`)

        return this.$router.push({name: 'companies.view', params: {
          companyId: data.data.id,
        }})
      }

      const {data} = await this.$http.get(`companies/get-isin?link=${encodeURI(company.link)}-company-profile`)

      if (data) {
        return await this.createCompany(data, company.name)
      }

      this.searched = true
    },

    async createFromSecurity (security) {
      await this.createCompany(security.isin, security.fullnm)
    },

    async createCompany (isin, name) {
      name = encodeURI(name).replace(/\//g, '')
      await this.$http.get(`companies/rapido/create-from-isin/${isin}/${name}`)

      this.$notify(infoNotification('You will recieve a notification when this company has been created.'))

      this.$router.replace({name: 'companies'})
    },

    async submitRequest () {
      try {
        const {data} = await this.$http.post('/companies/suggestions', this.company)
        this.$notify(successNotification(`Successfully requested ${data.data.name}`))
        this.$router.replace({name: 'companies'})
      } catch (e) {
        this.error = e.response.data
      }
    },
  },

}
</script>

<style lang="scss">
  $aside-width: 568px;
  .request-form {
    position: fixed;
    top: 0;
    right: -$aside-width;
    width: $aside-width;
    height: 100vh;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    background: white;
    z-index: 1000;
    box-shadow: 0 7px 32px rgba(0, 0, 0, 0.15);
    transition: right 0.3s ease;

    &--active {
      right: 0;
    }
  }
</style>
